import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["copyCheckbox", "siteField", "errorMessage", "checkboxContainer"]

  connect() {
    if (!this.siteFieldTarget.value) {
      this.copyCheckboxTarget.disabled = true
    } else {
      this.checkboxContainerTarget.classList.contains("opacity-60") &&
        this.checkboxContainerTarget.classList.remove("opacity-60")
    }
  }

  // The dates live on the task's periods (task_timespans), not on the task: copying fills the
  // first period that is still on the form — the site's run is one span, splitting it into more
  // periods stays the user's call. The nested-form template row and rows marked for removal
  // (hidden, not deleted) are skipped.
  //
  // The field is the picker's hidden ISO half, matched by form field name. The element carrying
  // the id is the visible half showing d.m.Y — writing to that would leave the text and the
  // submitted value disagreeing.
  dateField(attribute) {
    const rows = this.element.closest("form")?.querySelectorAll("[data-timespan-row]") ?? []
    const row = Array.from(rows).find(
      (candidate) => !candidate.closest("template") && candidate.style.display !== "none",
    )
    return row?.querySelector(
      `input[name^="task[task_timespans_attributes]"][name$="[${attribute}]"]`,
    )
  }

  // Assigning alone notifies nothing; the picker syncs its visible input off `change`.
  setDate(field, isoDate) {
    if (!field) return

    field.value = isoDate
    field.dispatchEvent(new Event("change", { bubbles: true }))
  }

  // The description is a rich-text field, and a form layout that hides it leaves it out of
  // the edit form entirely — so it may be missing.
  setDescription(value) {
    const taskDescription = document.getElementById("task_description")
    if (taskDescription) taskDescription.value = value
  }

  async copyConstruction(event) {
    const taskName = document.getElementById("task_name")
    const taskStartDate = this.dateField("start_date")
    const taskEndDate = this.dateField("end_date")
    if (event.target.checked) {
      const siteId = this.siteFieldTarget.value

      if (!siteId) {
        return
      }

      try {
        const response = await fetch(`/sites/${siteId}`)
        const siteData = await response.json()

        if (siteData) {
          taskName.value = siteData.name || taskName.value
          // sites#show already answers ISO, which is what the hidden field carries.
          if (siteData.start_date) this.setDate(taskStartDate, siteData.start_date)
          if (siteData.end_date) this.setDate(taskEndDate, siteData.end_date)
          this.setDescription(siteData.description || "")
        }
      } catch (error) {
        console.error("Error occured for copy construction: ", error)
      }
    } else {
      taskName.value = ""
      this.setDate(taskStartDate, "")
      this.setDate(taskEndDate, "")
      this.setDescription("")
    }
  }

  handleCheckboxMouseOver() {
    if (this.copyCheckboxTarget.disabled) {
      this.errorMessageTarget.classList.remove("hidden")
    }
  }

  handleCheckboxMouseOut() {
    if (this.copyCheckboxTarget.disabled) {
      this.errorMessageTarget.classList.add("hidden")
    }
  }

  selectedSite() {
    if (this.siteFieldTarget.value) {
      this.copyCheckboxTarget.disabled = false
      this.checkboxContainerTarget.classList.contains("opacity-60") &&
        this.checkboxContainerTarget.classList.remove("opacity-60")
    } else {
      this.copyCheckboxTarget.disabled = true
      !this.checkboxContainerTarget.classList.contains("opacity-60") &&
        this.checkboxContainerTarget.classList.add("opacity-60")
    }
  }
}
